// extracted by mini-css-extract-plugin
export default {"text":"LandingPage_text__9RPWl","fade-in":"LandingPage_fade-in__rxoWJ","image":"LandingPage_image__th4S4"};